const SCROLL_BOTTOM_TOLERANCE_PX = 8;

export const isContainerNearBottom = (container: HTMLElement) => {
  return container.scrollHeight - container.scrollTop - container.clientHeight <= SCROLL_BOTTOM_TOLERANCE_PX;
};
